import {
  isName,
  isMobileNumber,
  isPinCodeNumber,
  isAadhaarCardNumber,
  isPanCardNumber,
  isBankAccountNumber,
  isIfscCode,
  isUpiCode,
  isAlphaNumeric
} from "../utils/validators";

const OPTIONS = {
  weekday: "long",
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric"
};

export const getBase64Url = file => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  const base64 = new Promise(function(resolve, reject) {
    reader.onload = event => {
      if (event.target) resolve(event.target.result);
      else reject(new Error("fail"));
    };
  });
  return base64;
};

export const getPriceByWeight = (currentGoldPrice, weight) => {
  return currentGoldPrice * weight;
};

export const getWeightByPrice = (currentGoldPrice, price) => {
  return price / currentGoldPrice;
};

export const getAmountIncludedGst = amount => {
  return Number(amount * 1.03);
};

export const isAmountUpto2decimal = amount => {
  return /^\d*\.?\d{0,2}$/.test(amount);
};

export const isGoldUpto4decimal = amount => {
  return /^\d*\.?\d{0,4}$/.test(amount);
};

export const toaster = (_this, msg, position, duration) => {
  _this.$toasted.show(msg, {
    theme: "toasted-primary",
    duration: duration,
    position: position,
    closeOnSwipe: false,
    action: {
      text: "Close",
      onClick: (e, toastObject) => {
        toastObject.goAway(0);
      }
    }
  });
};

export const getGramBySellingPrice = (_amount, _sellingPrice) => {
     const calucatedPrice = ( _amount / _sellingPrice * Math.pow(10,5) ) % 10
     if (calucatedPrice <= 5) {
       return (Math.floor( _amount / _sellingPrice * Math.pow(10,4) ))/Math.pow(10,4)
     }
      return (Math.floor( _amount / _sellingPrice * Math.pow(10,4) )+1)/Math.pow(10,4)
}

export const roundDown = (n, decimals = 1) => {
  const divider = Math.pow(10, decimals);
  return Math.floor(n * divider) / divider;
};

export const roundOff = (n, decimals = 1) => {
  const divider = Math.pow(10, decimals);
  return Math.ceil(n * divider) / divider;
};

export const getDiscount = (amount, percentage) => {
  const discount = percentage / 100;
  return amount * discount;
};

export const getCurrentMonth = date => {
  return date.getMonth() + 1;
};

export const getFormattedDate = (date, formattedString) => {
  return (
    date.getDate() +
    formattedString +
    getCurrentMonth(date) +
    formattedString +
    date.getFullYear()
  );
};

export const getLongFormattedDate = (date, locale_stirng) => {
  return new Date(date).toLocaleDateString(locale_stirng, OPTIONS);
};

export const validateRegistrationForm = (_this, type) => {
  const {
    user_name,
    pan_no,
    pincode,
    aadhar_no,
    mobile_no,
    ifsc_code,
    upi_address,
    bank_account,
    re_bank_account,
    bank_holder_name
  } = _this.user;
  let form = {
    isValid: true
  };
  if (!user_name) {
    form.msg = _this.$t("fill_username");
    form.isValid = false;
  } else if (!isMobileNumber(mobile_no)) {
    form.msg = _this.$t("fill_phoneno");
    form.isValid = false;
  } else if (!isPinCodeNumber(pincode)) {
    form.msg = _this.$t("fill_pincode");
    form.isValid = false;
  } else if (!isAadhaarCardNumber(aadhar_no)) {
    form.msg = _this.$t("fill_aadhar");
    form.isValid = false;
  } else if (!isPanCardNumber(pan_no)) {
    form.msg = _this.$t("fill_panno");
    form.isValid = false;
  } else if (type === "bank") {
    if (!isName(bank_holder_name)) {
      form.msg = _this.$t("holder_name");
      form.isValid = false;
    } else if (!isBankAccountNumber(bank_account)) {
      form.msg = _this.$t("fill_bankaccount");
      form.isValid = false;
    } else if (re_bank_account != bank_account) {
      form.msg = _this.$t("confirmbankaccount");
      form.isValid = false;
    } else if (!isIfscCode(ifsc_code)) {
      form.msg = _this.$t("fill_ifsccode");
      form.isValid = false;
    }
  } else if (!isUpiCode(upi_address)) {
    form.msg = _this.$t("fill_upicode");
    form.isValid = false;
  } else if (!_this.tc) {
    form.msg = _this.$t("termsandcondition");
    form.isValid = false;
  }
  if (!form.isValid) {
    toaster(_this, _this.$t(form.msg), "top-left", 2000);
    return;
  }
  return form.isValid;
};

export const validateAddressForm = _this => {
  const {
    pincode,
    city,
    state,
    landmark,
    customer_name,
    phone_number,
    street,
    house_no
  } = _this.useraddress;
  let _addressForm = {
    isValid: true
  };
  if (!isName(customer_name)) {
    _addressForm.msg = _this.$t("fill_fullname");
    _addressForm.isValid = false;
  } else if (!isPinCodeNumber(pincode)) {
    _addressForm.msg = _this.$t("fill_pincode");
    _addressForm.isValid = false;
  } else if (!isName(city)) {
    _addressForm.msg = _this.$t("fill_city");
    _addressForm.isValid = false;
  } else if (!isName(state)) {
    _addressForm.msg = _this.$t("fill_state");
    _addressForm.isValid = false;
  } else if (!isAlphaNumeric(house_no)) {
    _addressForm.msg = _this.$t("fill_houseno");
    _addressForm.isValid = false;
  } else if (!isMobileNumber(phone_number)) {
    _addressForm.msg = _this.$t("fill_mobileno");
    _addressForm.isValid = false;
  } else if (!isAlphaNumeric(street)) {
    _addressForm.msg = _this.$t("fill_street");
    _addressForm.isValid = false;
  } else if (!isAlphaNumeric(landmark)) {
    _addressForm.msg = _this.$t("fill_landmark");
    _addressForm.isValid = false;
  }
  if (!_addressForm.isValid) {
    toaster(_this, _this.$t(_addressForm.msg), "top-left", 2000);
    return;
  }
  return _addressForm.isValid;
};
